import React from 'react'
import styled, { keyframes, css } from 'styled-components'
import bankIcon from './../images/bank-icon@2x.png'
import arrowIcon from './../images/arrow-forward.png'

const leftToRight = keyframes`
    from {
        transform: translateX(-32px);
        opacity: 0;
    }

    to {
        transform: translateX(8px);
        opacity: 1;
    }
`

const rightToLeft = keyframes`
    from {
        transform: translateX(32px);
        opacity: 0;
    }

    to {
        transform: translateX(-8px);
        opacity: 1;
    }
`

const Wrapper = styled.div`
    height: 96px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
`
const AppIcon = styled.img`
    width: 64px;
    height: 64px;
    box-shadow: 0px 8px 16px 0px rgba(23,28,28,0.08);
    border-radius: 16px;
    background-color: white;
    overflow: hidden;
    object-fit: cover;
    animation: ${rightToLeft} 300ms linear forwards;

    ${props => props.right && css`
        animation: ${leftToRight} 300ms linear forwards;
    `}
`
const LeanIcon = styled.img`
    width: 56px;
    height: 56px;
`

const ConnectIllustration = ({ appIcon, applicationName }) => (
    <Wrapper>
        <AppIcon src={appIcon} alt={applicationName} />
        <LeanIcon src={arrowIcon} alt="Lean" />
        <AppIcon src={bankIcon} alt="Bank" right />
    </Wrapper>
)

export default ConnectIllustration